import throttle from 'hs-lodash/throttle';
import { useEffect, useState } from 'react';
import { WindowDimensionsContext } from '../context/WindowDimensionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function WindowDimensionsProvider({
  children
}) {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    deviceWidth: window.screen.width,
    deviceHeight: window.screen.height
  });
  useEffect(() => {
    const handleResize = throttle(() => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
        deviceWidth: window.screen.width,
        deviceHeight: window.screen.height
      });
    }, 100);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return /*#__PURE__*/_jsx(WindowDimensionsContext.Provider, {
    value: dimensions,
    children: children
  });
}